import { sanitize } from '@brandfolder/utilities';
import PropTypes from 'prop-types';
import React, { useState } from "react";

import renderModal from '@components/show_page/modals/renderModal';

function AddLabelModal(props) {
  const [labelName, updateName] = useState([]);

  const createLabel = () => {
    const { addLabel, activeLabel } = props;
    const newLabelData = { name: sanitize(labelName), parent_key: activeLabel.parentKey };
    addLabel(newLabelData);
  };

  const submitIfEnter = (e) => {
    if (e.key === 'Enter') {
      createLabel();
    }
  };

  const { toggleModal, activeLabel } = props;
  const parentName = activeLabel.parentName ? `under ${activeLabel.parentName}` : "at top level";

  return (
    <div className="modal-content-wrapper add-labels-modal">
      <div className="modal-content-wrapper__header">
        <span aria-hidden="true" className="bff-label icon" />
        <h3 className="modal-title">{bfTranslate("Add Label")}</h3>
      </div>
      <div className="modal-content-wrapper__body">
        <h3 className="body-title">
          {`${bfTranslate('Add new label')} ${parentName}`}
        </h3>
        <label className="brandfolder-label" htmlFor="name">
          {bfTranslate('Name')}
          <input
            autoFocus
            className="brandfolder-input form-html-label"
            id="name"
            name="name"
            onChange={(e) => updateName(e.target.value)}
            onKeyUp={submitIfEnter}
            placeholder="Label Name"
            type="text"
          />
        </label>
        <div className="button-container">
          <button
            className="button tertiary sm t-close-modal"
            onClick={() => toggleModal()}
            type="button"
          >
            {bfTranslate('Cancel')}
          </button>
          <button
            className="button sm primary t-confirm-modal"
            disabled={!labelName.length}
            onClick={createLabel}
            type="button"
          >
            {bfTranslate('Add')}
          </button>
        </div>
      </div>
    </div>
  );
}

AddLabelModal.propTypes = {
  toggleModal: PropTypes.func.isRequired,
  addLabel: PropTypes.func.isRequired,
  activeLabel: PropTypes.shape({
    actionType: PropTypes.string,
    parentKey: PropTypes.string,
    name: PropTypes.string,
  }).isRequired
};

const ModalComponent = renderModal(AddLabelModal, 'AddLabelModal');
export default ModalComponent;
